import { PipeTransform, Pipe } from '@angular/core';
@Pipe({
    name: 'reversePipe'
})
export class ReversePipe implements PipeTransform {
    transform(value: any): any {
      return value.slice().reverse();
    }
}
